// extracted by mini-css-extract-plugin
export default {"chat-console":"ChatConsole_chat-console__82RR7"};